import { render, staticRenderFns } from "./ContactRetrieveUpdate.vue?vue&type=template&id=5163cd5b"
import script from "./ContactRetrieveUpdate.vue?vue&type=script&lang=js"
export * from "./ContactRetrieveUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports